import React, { useEffect, useRef, useState } from "react";
import { Key, LockKeyhole } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../slices/authSlice";
import { AlignCenter, Bell, CircleUser, LogOut } from "lucide-react";
import down from "../../assets/images/svg/down-icon.svg";
import bg from "../../assets/media/photos/bg.png";
import { toast } from "react-toastify";
import { fetchData } from "../../utils/functions";
import Logo2 from "../../assets/media/photos/uripion-union2.png";
import Logo3 from "../../assets/media/photos/UNIDO-w.png";
import GosSphfLogo from "../../assets/media/photos/logo1.png";

const HeaderMain = ({ toggleSidebar, sidebarVisible }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenProfile, setIsOpenProfile] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, message: "Record #123 approved", status: "unread" },
    { id: 2, message: "Record #456 rejected", status: "unread" },
  ]);
  const dropdownRef = useRef(null);
  const profileDropdownRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state?.auth);

  const toggleProfileDropdown = () => {
    setIsOpenProfile((prev) => {
      if (!prev) setIsOpen(false);
      return !prev;
    });
  };

  const toggleNotificationDropdown = () => {
    setIsOpen((prev) => {
      if (!prev) setIsOpenProfile(false);
      return !prev;
    });
  };

  const handleLogout = async () => {
    await dispatch(logoutUser());
    navigate("/login", { replace: true });
  };

  const markAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, status: "read" } : n))
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        setIsOpenProfile(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header
      className="fixed z-[10] top-0 left-0 w-full transition-all duration-100"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="flex items-center justify-between h-[4rem]">
        {/* Sidebar Toggle + Logos */}
        <div className="flex justify-start">
          <button
            className={`fixed top-4 outline-none rounded-md z-[104] p-2 shadow-lg bg-[#be9609] transition-all duration-300 ${
              sidebarVisible ? "left-[17rem]" : "lg:left-24 left-3"
            }`}
            onClick={toggleSidebar}
          >
            <AlignCenter size={17} color="#fff" />
          </button>
          <div
            className={`fixed top-3 flex items-center gap-3 outline-none rounded-md z-[104] transition-all duration-300 ${
              sidebarVisible ? "lg:left-[20rem] left-0" : "lg:left-36 left-14"
            }`}
          >

            <img src={Logo3} alt="UNIDO" className="w-[50px]" />
            <img src={GosSphfLogo} alt="Government of Sindh" className="h-8 aspect-[95/97] object-cover object-left brightness-0 invert" />
            <img src={GosSphfLogo} alt="SPHF" className="h-8 aspect-[233/97] object-cover object-right brightness-0 invert" />

            <svg width="0" height="0" className="absolute" aria-hidden="true">
              <filter id="eu-white-stars" colorInterpolationFilters="sRGB">
                <feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  2.5 0 -2.5 0 -0.5" />
              </filter>
              <filter id="eu-white-text" colorInterpolationFilters="sRGB">
                <feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  -2.6 0 2.6 0 -0.6" />
              </filter>
            </svg>
            <div className="relative h-7 aspect-[1128/803] overflow-hidden shrink-0">
              <img src={Logo2} alt="European Union" className="absolute max-w-none w-[136.17%] left-[-18.09%] top-[-13.45%] [filter:url(#eu-white-stars)] [clip-path:inset(10%_0_23.8%_0)]" />
              <img src={Logo2} alt="" aria-hidden="true" className="absolute max-w-none w-[136.17%] left-[-18.09%] top-[-13.45%] [filter:url(#eu-white-text)] [clip-path:inset(77.6%_0_0_0)]" />
              <div className="absolute left-0 top-0 w-full h-[82.6%] border-[0.5px] border-white/80" aria-hidden="true" />
            </div>
          </div>
        </div>

        {/* Right Section: Bell + Profile */}
        <div className="flex items-center gap-4 mr-4">
          {/* 🔔 Notification Bell */}
          {/* <div className="relative" ref={dropdownRef}>
            <button
              className="relative p-2 text-white"
              aria-expanded={isOpen}
              onClick={toggleNotificationDropdown}
              id="notificationDropdownButton"
            >
              <Bell size={20} />
              {notifications.filter((n) => n.status === "unread").length >
                0 && (
                <span className="absolute -top-1 -right-2 bg-red-600 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {notifications.filter((n) => n.status === "unread").length}
                </span>
              )}
            </button>
            <div
              className={`absolute right-0 top-9 bg-white text-sm text-black border border-gray-200 shadow-lg rounded-md w-[18rem] max-h-[300px] overflow-y-auto ${
                isOpen ? "block" : "hidden"
              }`}
            >
              {notifications.length === 0 && (
                <div className="p-4 text-gray-500">No notifications</div>
              )}
              {notifications.map((n) => (
                <div
                  key={n.id}
                  onClick={() => markAsRead(n.id)}
                  className={`p-3 cursor-pointer border-b last:border-b-0 ${
                    n.status === "unread"
                      ? "bg-gray-100 font-semibold"
                      : "bg-white"
                  } hover:bg-gray-200`}
                >
                  {n.message}
                  <div className="text-xs text-gray-400">
                    {n.status === "unread" ? "New" : "Read"}
                  </div>
                </div>
              ))}
            </div>
          </div> */}

          {/* 👤 Profile Dropdown */}
          <div
            className="lg:relative w-auto bg-[#ebeef2] px-3 py-1 rounded-md flex items-center ml-4"
            ref={profileDropdownRef}
          >
            <button
              id="mainHeaderProfile"
              className="flex items-center text-black"
              aria-expanded={isOpenProfile}
              onClick={toggleProfileDropdown}
            >
              <div className="w-6 h-6 rounded-full bg-white text-[#0f3771] flex items-center justify-center font-semibold">
                {user?.user.user_name?.charAt(0).toUpperCase() || "A"}
              </div>
              <div className="hidden md:flex flex-col items-start gap-[1px] ml-2 ">
                <span className="flex gap-[1px]">
                  <p className="text-[15px] leading-none">
                    {user?.user.user_name}
                  </p>
                  <img src={down} alt="dropdown" width={15} />
                </span>
              </div>
            </button>

            <ul
              className={`absolute top-[3.3rem] bg-white right-0 mt-2 w-48 rounded-md shadow-lg ${
                isOpenProfile ? "block" : "hidden"
              }`}
              id="profileDropdown"
            >
              <li className="hover:bg-gray-100">
                <a href="/profile" className="flex items-center gap-2 p-3">
                  <CircleUser size={15} /> Profile
                </a>
              </li>
              <li className="hover:bg-gray-100">
                <button
                  onClick={() => {
                    setIsOpenProfile(false);
                    navigate("users/change-password");
                  }}
                  className="flex items-center gap-2 p-3 w-full text-left"
                >
                  <LockKeyhole size={15} /> Change Password
                </button>
              </li>
              <li className="hover:bg-gray-100">
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 p-3 w-full text-left"
                >
                  <LogOut size={15} /> Log Out
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderMain;
